import React from 'react';
import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import { reactSelectStyle } from '../../componentStyles';
import { None, MIN_PRICE } from '../../constants';
import setActiveBrand from '../../redux/actions/carBrand';
import setActiveModel from '../../redux/actions/carModel';
import setPrice from '../../redux/actions/price';
import setSearchCars from '../../redux/actions/searchCars';

export default () => {
  const carBrand = useSelector((state) => state.search.Brand);
  const carModel = useSelector((state) => state.search.Model);
  const price = useSelector((state) => state.price.prices[1]);
  const dispatch = useDispatch();
  const { dictionary, carBrands, language } = startup;
  const defaultOption = { value: None, label: dictionary.None };
  const brandOptions = Object.keys(carBrands).map((el) => ({
    value: el,
    label: el,
  }));
  const modelOptions = carBrand
    ? [
        defaultOption,
        ...carBrands[carBrand].map((el) => ({ value: el, label: el })),
      ]
    : [defaultOption];
  const priceOptions = [5000, 10000, 20000, 30000, 40000, 50000].map((el) => ({
    value: el,
    label: `Max € ${el}`,
  }));

  const getFormResult = () => {
    const searchCarForm = document.querySelector('#searchCarForm');
    const formResult = new FormData(searchCarForm);
    const data = new Map(formResult);
    data.set('MinPrice', MIN_PRICE);
    data.set('MaxPrice', price);
    // if (data.get('Brand') === None) {
    //   alert('Choose at least a brand, please!');
    //   return;
    // } // check form
    dispatch(setSearchCars(startup.cars, data));
  };

  const catalogOptions = JSON.stringify({ carBrand, carModel, price });
  return (
    <form className="b-find__form" id="searchCarForm">
      <div className="b-find__row">
        <div className="b-find__main">
          <div className="b-find__inner">
            <div className="b-find__item">
              <div className="b-find__label">
                <span className="b-find__number">1</span>
                {dictionary.Brand}
              </div>
              <div className="b-find__selector">
                <input
                  value={carBrand || None}
                  form="searchCarForm"
                  name="Brand"
                  hidden
                  readOnly
                />
                <Select
                  // Car Brand
                  styles={reactSelectStyle}
                  className="catalogFilter brand"
                  placeholder={dictionary.Brand}
                  options={brandOptions}
                  value={carBrand ? { value: carBrand, label: carBrand } : null}
                  onChange={(option) => {
                    dispatch(setActiveBrand(option.value));
                    dispatch(setActiveModel(defaultOption.value));
                  }}
                />
              </div>
            </div>
            <div className="b-find__item">
              <div className="b-find__label">
                <span className="b-find__number">2)</span>
                {dictionary.Model}
              </div>
              <div className="b-find__selector">
                <input
                  value={carModel || None}
                  form="searchCarForm"
                  name="Model"
                  hidden
                  readOnly
                />
                <Select
                  // Car Model
                  styles={reactSelectStyle}
                  className="catalogFilter model"
                  placeholder={dictionary.Model}
                  options={modelOptions}
                  value={
                    carModel
                      ? modelOptions.find((el) => el.value === carModel)
                      : null
                  }
                  onChange={(option) => dispatch(setActiveModel(option.value))}
                />
              </div>
            </div>
            <div className="b-find__item">
              <div className="b-find__label">
                <span className="b-find__number">3)</span>
                {dictionary.Price}
              </div>
              <div className="b-find__selector">
                <Select
                  // Price
                  styles={reactSelectStyle}
                  className="catalogFilter"
                  placeholder={dictionary.Price}
                  options={priceOptions}
                  value={
                    price ? priceOptions.find((el) => el.value === price) : null
                  }
                  onChange={(option) =>
                    dispatch(setPrice([MIN_PRICE, option.value]))
                  }
                />
              </div>
            </div>
            <a
              className="b-find__item b-find__btn btn btn-primary"
              href={`../${language}/catalog/${catalogOptions}`}
              onClick={() => getFormResult()}
            >
              {dictionary.SearchACar}{' '}
            </a>
          </div>
        </div>
      </div>
    </form>
  );
};
